export default class Modal {
  constructor(component = {}) {
    this.el = component.el;
    this.modalInnerEl = this.el.querySelector('[data-modal-inner]');
    this.contentsEl = this.el.querySelector('[data-modal-contents]');
    this.closeEl = this.el.querySelector('[data-modal-close]');

    this.el.addEventListener('click', () => this.close());
    this.modalInnerEl.addEventListener('click', e => e.stopPropagation());
    this.closeEl.addEventListener('click', () => this.close());

    this.selectors = {
      open: 'modal-opened',
      visible: 'modal-visible',
      active: 'modal-active',
      scrollLock: 'scroll-locked',
    };

    this.callbacks = {
      ...{
        onOpen: () => ({}),
        onClose: () => ({}),
      },
      ...component.callbacks,
    };
  }

  // Manually open a modal.
  open() {
    this.el.classList.add(this.selectors.open);

    // Use onOpen to insert contents into modal
    return this.callbacks.onOpen({
      modal: this.el,
      contents: this.contents,
    });
  }

  // Close modal, and clean up
  close() {
    this.el.classList.remove(this.selectors.active);
    this.el.classList.remove(this.selectors.visible);
    this.el.classList.remove(this.selectors.open);

    document.body.classList.remove(this.selectors.scrollLock);

    this.contentsEl.innerHTML = '';

    this.callbacks.onClose();
  }

  /* Make a modal visible after content has been added */
  showModal() {
    document.body.classList.add(this.selectors.scrollLock);
    this.el.classList.add(this.selectors.visible);

    $(this.el).one('trend', () => this.el.classList.add(this.selectors.active));
  }
}
